import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Text, TextType } from 'ui-components/components/text';

import { Providers } from '../../../../enums/providers';
import { useModal } from '../../../../hooks/use-modal';
import { AmazonPickup } from '../../../../carrier-pickup/carrier-pickup-modal-v2/amazon-pickup';
import { useUserSetting } from '../../../../hooks/use-user-setting';
import { UserSettings } from '../../../../enums/user-settings/user-settings';

import messages from './messages';
import style from './service-details.module.less';

export const AmazonShippingDisclaimer = ({ labelProviderId, sellerLabelProviderId = undefined }) => {
  const isAmazonShipping = labelProviderId ? labelProviderId.toString() === Providers.AmazonShippingWalleted.labelProviderId : false;
  const isAmazonShippingFirstLabelCreated = useUserSetting(UserSettings.isAmazonShippingFirstLabelCreated.settingName);

  const showDisclaimer = isAmazonShipping && !!sellerLabelProviderId && !isAmazonShippingFirstLabelCreated;
  const { isOpen, open, close } = useModal();

  if (!showDisclaimer) {
    return null;
  }

  return (
    <>
      <Text
        className={style['amazon-shipping-note']}
        formattedMessageValues={{
          link: (chunks) => (
            <Button onClick={open} theme={THEME_CONSTANTS.link}>
              {chunks}
            </Button>
          ),
        }}
        textType={TextType.Caption}
        value={messages.amazonShippingNote}
      />
      {isOpen && <AmazonPickup onClose={close} sellerLabelProviderId={sellerLabelProviderId} />}
    </>
  );
};
